import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Toast.css';

const propTypes = {
  message: PropTypes.string,
  sureStyle: PropTypes.oneOf(['default', 'success', 'error', 'info']),
}

const defaultProps = {
  message: null,
  sureStyle: 'default',
}

class Toast extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDismissed: false,
    };
  }

  componentDidMount() {
    setTimeout(this.handleDismiss.bind(this), 5000);
  }

  get classes() {
    let className = `Toast Toast--${this.props.sureStyle}`;
    if (this.state.isDismissed) {
      className += ' is-dismissed';
    }
    return className;
  }

  handleDismiss() {
    this.setState({
      isDismissed: true,
    });
    setTimeout(this.props.onDismiss, 500);
  }

  render() {
    return (
      <div
        className={this.classes}
        onClick={this.handleDismiss.bind(this)}>
        {this.props.message}
      </div>
    );
  }
}

Toast.propTypes = propTypes;
Toast.defaultProps = defaultProps;

export default Toast;
